export default "__VITE_ASSET__BRfUe1SG__"